/**
 * @module core/actions
 */
const MOUNT_VIEW = 'MOUNT_VIEW';
const UNMOUNT_VIEW = 'UNMOUNT_VIEW';

export { MOUNT_VIEW, UNMOUNT_VIEW };
